import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/news/[slug]/page.tsx");
